import {showToast} from '@/components/Toaster/Toaster';

export const useIlluminationModeHandlers = ({
    notifications,
    popup,
    resetUIState,
    setUiLedIntensity,
    updateIlluminationMode,
}) => {
    const handleSuccess = (newPopupValueType) => {
        const popupValue = popup?.groups?.values.find((v) => v.type === newPopupValueType);
        const title = notifications.changedTitle?.replace('{0}', popupValue?.icon?.title || '');

        showToast(title);
    };

    const handleError = (newPopupValueType) => {
        resetUIState();
        const popupValue = popup?.groups?.values.find((v) => v.type === newPopupValueType);
        const title = notifications.unsuccessfulTitle;
        const description = notifications.unsuccessfulDescription?.replace('{0}', popupValue?.icon?.title || '');

        showToast(title, {
            description,
            action: {
                label: notifications.unsuccessfulButton.text,
                onClick: () => {
                    setUiLedIntensity(newPopupValueType);
                    updateIlluminationMode(newPopupValueType);
                },
            },
        });
    };

    return {handleSuccess, handleError};
};
